import { render, staticRenderFns } from "./ErstelleAmazonLand.vue?vue&type=template&id=16612c78&"
import script from "./ErstelleAmazonLand.vue?vue&type=script&lang=js&"
export * from "./ErstelleAmazonLand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports